import { AuthenticationGuard } from '../../authentication.guard';
import { LegacyPageAccessGuard } from '../../legacy-page-access.guard';

export const AUTH_GUARDS = [AuthenticationGuard];
export const LEGACY_ROUTE_GUARDS = [AuthenticationGuard, LegacyPageAccessGuard];

/** @deprecated Use LEGACY_ROUTE_GUARDS for legacy routes or AUTH_GUARDS for modern frame routes. */
export const ROUTE_GUARDS = LEGACY_ROUTE_GUARDS;
